<div class="fix-action-dialog">
	<mat-dialog-header fxLayoutAlign="start center" style="font-size: 18px;font-weight: 700;color: #fdfdfd;">
		<mat-icon style="font-size: 24px;">play_arrow</mat-icon>
		<h3 class="card-title" style="padding-left: 8px;"><span translate>AIGIAメソッド動画</span></h3>
		<!--<div style="font-size:12px;">{{data.content.filename}}</div> -->
	</mat-dialog-header>

	<mat-dialog-content>
		<div fxFlex="100" fxLayout="column">
			<div fxFlex="80">
				<video controls fxFlex="100" muted playsinline>
					<source data-idtest="video-dialog-b-1Ho" src="{{data.content.path}}">
				</video>
			</div>
			<div fxFlex="20" fxFlexAlign="center center" style="font-weight:700;background-color:#000000;color:#fdfdfd;padding: 12px;">
				<span class="video-description" translate>{{data.content.metadata.description}}</span>
			</div>
		</div>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around">
		<button data-idtest="video-dialog-b-9Ut" (click)="cancel()" color="warn" mat-dialog-close="" mat-raised-button><span translate>閉じる</span></button>
	</mat-dialog-actions>

</div>
